import styled from 'styled-components';

export const StyledWeatherFlagCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .content {
    font-size: 14px;
    font-weight: 400;
    color: #585959;
  }
`;
